import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { UserSessionExpirationComponent } from './user-session-expiration.component';

export { UserSessionExpirationModule } from './user-session-expiration.module';
export const ngxUserSessionExpirationModule = angular.module('ngxUserSessionExpirationModule', [])
	.directive('ngxUserSessionExpiration', downgradeComponent({ component: UserSessionExpirationComponent }))
	.name;
